import React from "react"
import FieldDocumentAccess from "./access"
import FieldConfig from "../../../proto/field-config";

const debug = false
// const debug = "FieldDocumentAccessWrite"

export default class FieldDocumentAccessWrite extends FieldDocumentAccess {

    constructor(config:FieldConfig) {
        super(config)

        this.icon       = "i5-pen"
    }
}